import { Grid, Typography, theme } from "antd";

const LABEL_WIDTH = 160;

// One titled block of a detail view, laid out on a fixed grid so labels and
// values line up across every section:
//   wide screens:  [label][value][label][value]  (an item with `span: 2` takes the whole row)
//   small screens: [label][value]
// Items use the same shape as antd Descriptions items: { label, children, span }.
export default function DetailSection({ title, items }) {
  const screens = Grid.useBreakpoint();
  const { token } = theme.useToken();
  const twoColumns = !!screens.md;

  const border = `1px solid ${token.colorBorderSecondary}`;
  const cell = {
    padding: "8px 12px",
    borderRight: border,
    borderBottom: border,
    minWidth: 0,
    wordBreak: "break-word",
    // Vertically center labels and values (text, switches, selects) in a row.
    display: "flex",
    alignItems: "center",
  };
  const labelCell = {
    ...cell,
    backgroundColor: token.colorFillAlter,
    color: token.colorTextSecondary,
    fontWeight: 400,
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Typography.Text
        strong
        style={{ display: "block", fontSize: 13, marginBottom: 8 }}
      >
        {title}
      </Typography.Text>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: twoColumns
            ? `${LABEL_WIDTH}px minmax(0, 1fr) ${LABEL_WIDTH}px minmax(0, 1fr)`
            : `${LABEL_WIDTH - 30}px minmax(0, 1fr)`,
          borderTop: border,
          borderLeft: border,
          borderRadius: token.borderRadiusLG,
          overflow: "hidden",
          fontSize: token.fontSize,
        }}
      >
        {items.filter(Boolean).map((item, index) => {
          const fullWidth = !twoColumns || (item.span ?? 1) >= 2;
          return [
            <div key={`label-${index}`} style={labelCell}>
              {item.label}
            </div>,
            <div
              key={`value-${index}`}
              style={{
                ...cell,
                gridColumn: fullWidth && twoColumns ? "span 3" : undefined,
              }}
            >
              {item.children ?? "-"}
            </div>,
          ];
        })}
      </div>
    </div>
  );
}
